import { createAsyncAction, createStandardAction } from 'typesafe-actions';
import { SortFolderOptions } from '../../utilities';

export type LoadLibraryPageParams = {
  folderId?: string;
  profileId?: string;
  search?: string;
};

export const loadLibraryPage =
  createStandardAction('@LIBRARY_PAGE/LOAD')<LoadLibraryPageParams>();

export const loadRootLibraryPage = createStandardAction(
  '@LIBRARY_PAGE/ROOT/LOAD',
)<{
  profileId?: string;
}>();

export const unloadLibraryPage = createStandardAction('@LIBRARY_PAGE/UNLOAD')();

export const loadLibraryPageAsync = createAsyncAction(
  '@LIBRARY_PAGE/LOAD_REQUEST',
  '@LIBRARY_PAGE/LOAD_SUCCESS',
  '@LIBRARY_PAGE/LOAD_FAILURE',
)<void, void, Error>();

export const loadRootLibraryPageAsync = createAsyncAction(
  '@LIBRARY_PAGE/ROOT/LOAD_REQUEST',
  '@LIBRARY_PAGE/ROOT/LOAD_SUCCESS',
  '@LIBRARY_PAGE/ROOT/LOAD_FAILURE',
)<void, void, Error>();

export const setMainSortOptions = createStandardAction(
  '@LIBRARY_PAGE/SET_MAIN_SORT_OPTIONS',
)<SortFolderOptions>();

export const setSideSortOptions = createStandardAction(
  '@LIBRARY_PAGE/SET_SIDE_SORT_OPTIONS',
)<SortFolderOptions>();

export const setSearchQuery = createStandardAction(
  '@LIBRARY_PAGE/SET_SEARCH_QUERY',
)<string>();

export const setSelectedNodeIds = createStandardAction(
  '@LIBRARY_PAGE/SET_SELECTED_NODE_IDS',
)<string[]>();

export const clearSelectedNodeIds = createStandardAction(
  '@LIBRARY_PAGE/CLEAR_SELECTED_NODE_IDS',
)();

export const toggleLayoutOptions = createStandardAction(
  '@LIBRARY_PAGE/TOGGLE_LAYOUT_OPTIONS',
)();

export const setManageMode = createStandardAction(
  '@LIBRARY_PAGE/SET_MANAGE_MODE',
)<boolean>();
